import React from 'react';
import CollapsableMenu from 'components/containers/CollapsableMenu';
import useUserDocuments from 'hooks/requests/user/hooks/useUserDocuments';
import { DocumentGroupName } from '../../../../../../types/documents-types';
import { getSubscriptionDocuments } from '../../../../../../utils/documents_utils';
import ProfileDocumentsEmpty from 'pages/profile/components/ProfileTabContent/ProfileDocuments/ProfileDocumentsEmpty';
import ProfileDocumentsLoading from 'pages/profile/components/ProfileTabContent/ProfileDocuments/ProfileDocumentsLoading';
import { createTaxesItems } from 'pages/profile/components/ProfileTabContent/ProfileDocuments/ProfileDocumentsTax/utils';

const ProfileDocumentsTax = () => {
  const { userTaxesDocuments, loading } = useUserDocuments();
  const taxes = getSubscriptionDocuments(
    DocumentGroupName.TAXES,
    userTaxesDocuments
  );
  const newTaxes = taxes.map((tax) => tax[0]);
  const taxesItems = createTaxesItems(newTaxes);

  if (loading) {
    return <ProfileDocumentsLoading />;
  }

  if (taxesItems?.[0]?.rows.length === 0) {
    return <ProfileDocumentsEmpty />;
  }

  return <CollapsableMenu items={taxesItems} />;
};

export default ProfileDocumentsTax;
